<template>
    <div class="addons">

        <article class="wrap--product">

            <header class="addons__header border-b padding-b-25 margin-b-50">

                <h1>{{selection.title}}</h1>
                <h2 :class="{'error': selectedQuantity !== selection.min_options, 'success': selectedQuantity === selection.min_options}" v-if="selection.min_options > 0"> Vælg: {{selectedQuantity}} / {{selection.min_options}} stk. <transition name="fade"> <i class="fas fa-check" v-if="selectedQuantity === selection.min_options"></i></transition></h2>


            </header>

            <main class="addons__items">

                <option-item v-for="option in selection.options" :option="option" :selection="selection" :key="option.id"></option-item>

            </main>

        </article>

    </div>

</template>

<script>
    import Option from './option.vue';
    import {mapGetters} from 'vuex';
    export default {
        name: "selection",
        components:{
            'option-item':Option,
        },
        props:{
            selection:{
                type: Object,
                required: true,
            }
        },
        computed: {
            ...mapGetters({
                product: 'product',
                order: 'order',
            }),
            selectedQuantity(){
                return this.order.details.selections.find(item => item.selection_id === this.selection.id).options.length;
            }
        },
    }
</script>

<style scoped>

</style>
